module.exports = __webpack_public_path__ + "img/checkbox_inactive.844a9adb.svg";